module.exports = __webpack_public_path__ + "img/PAPAKIKE-SELE.956d3868.jpg";